$(function () {
    let textSlider = $('.text-slider');
    console.log(textSlider);
    if (textSlider.length > 0) {
        textSlider.slick({
            arrows: false,
            dots: true,
            draggable: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 7000,
            asNavFor: '.side-image-slider'
        });
    }
    let sideImageSlider = $('.side-image-slider');
    if (sideImageSlider.length > 0) {
        sideImageSlider.slick({
            arrows: false,
            dots: false,
            draggable: false,
            slidesToScroll: 1,
            slidesToShow: 1,
            asNavFor: '.text-slider'
        });
    }
})